<template>
  <div id="channelEditUser" v-loading="isLoging">
    <el-dialog
      title="通道权限编辑"
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div id="shared" style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="form" :rules="rules" :model="form" label-width="200px" >

          <el-form-item label="设备编号" prop="deviceId">
            <el-input v-if="isEdit" v-model="form.deviceId" disabled></el-input>
            <el-input v-if="!isEdit" v-model="form.deviceId" clearable></el-input>
          </el-form-item>

          <el-form-item label="通道编号" prop="deviceId">
            <el-input v-if="isEdit" v-model="form.deviceId" disabled></el-input>
            <el-input v-if="!isEdit" v-model="form.deviceId" clearable></el-input>
          </el-form-item>

          <el-form-item label="通道名称" prop="name">
            <el-input v-model="form.name" :readonly="true" clearable></el-input>
          </el-form-item>


          <el-form-item  label="公司或个人" prop="isRelatedJjsCompany" >
            <el-input v-model="deviceInfo.isRelatedJjsCompanyType" :readonly="true" clearable></el-input>
          </el-form-item>
          


          <!-- 公司 multiple （多选） collapse-tags （收缩）-->
          <el-form-item label="公司" prop="companyName" v-if="deviceInfo.isRelatedJjsCompany==1">
            <!-- <el-input v-model="deviceInfo.companyName" :readonly="true" clearable></el-input> -->
            <template > 
                <div v-if="deviceInfo.companyName">
                  <p v-for="(item,i) in deviceInfo.companyName.split(',')" :key="i">
                    {{item}}
                  </p>
                </div>
                <p v-else>无</p>
            </template>
          </el-form-item>

          <el-form-item label="个人" prop="userName" v-if="deviceInfo.isRelatedJjsCompany==2">
            <el-input v-model="deviceInfo.userName" :readonly="true" clearable></el-input>
          </el-form-item>

          <el-form-item label="船舶或者岸基" prop="shipName"  v-if="deviceInfo.isRelatedJjsCompany==1">
            <el-input v-model="deviceInfo.shipName" :readonly="true" clearable></el-input>
          </el-form-item>


          
          <el-form-item label="设备状态" prop="status" >
            <el-input v-model="deviceInfo.status" :readonly="true" clearable></el-input>
          </el-form-item>

          
          <el-form-item label="备注" prop="remark">
            <el-input v-model="deviceInfo.remark" clearable maxlength="100"></el-input>
          </el-form-item>

          <el-form-item label="权限控制" prop="userSelect">
            <el-tree
            :data="companyUserTree"
            show-checkbox
            node-key="id"
            ref="tree" >
          </el-tree>
            
          </el-form-item>


          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit" >确认</el-button>
              <el-button @click="close">取消</el-button>
            </div>

          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MediaServer from '../service/MediaServer'
export default {
  name: "channelEditUser",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      hostNames:[],
      mediaServerList: [], // 滅体节点列表
      mediaServerObj : new MediaServer(),
      form: {},
      formRest: {},
      isEdit: false,
      rules: {
        deviceId: [{ required: true, message: "请输入设备编号", trigger: "blur" }]
      },
      shipName: "" ,
      companyId: "" ,
      shipCompanyId : "" ,
      deviceInfo : {} ,
      defaultUserTree : [] ,
      companyUserTree : [] ,

    };
  },

  methods: {
    openDialog: function (row, callback) {
      
      this.deviceInfo = JSON.parse(sessionStorage.getItem('deviceInfo')) ;  

      var userList = JSON.parse(sessionStorage.getItem('userList')) ;  

      console.log( userList ) ;
      /**
       * 组装
       * channelId: "34020000001320000061"
       * companyId: "65727c35533b152ac51e9e20"
       * companyName: "重庆鑫鸿联国际物流有限责任公司"
       * deviceId: "34020000001110000099"
       * userId: "658bb53c2c37f4042bb44346"
       * userName: "张云峰"
       */
      this.defaultUserTree = [] ;
      if( userList && userList.length > 0 ){
        userList.forEach( e =>{
          this.defaultUserTree.push(  e.userId + "__" + e.userName + "__" + e.companyId + "__" +  e.companyName  ) ; 
        })
      }

      if( this.deviceInfo.isRelatedJjsCompany == 1 ){
        this.deviceInfo.isRelatedJjsCompanyType = "公司";
      }else{
        this.deviceInfo.isRelatedJjsCompanyType = "个人";
      }
      if( this.deviceInfo.status == 1 ){
        this.deviceInfo.status = "开启";
      }else{
        this.deviceInfo.status = "关闭";
      }

      this.shipName = this.deviceInfo.shipName ; 
      // console.log( this.deviceInfo );
      if( this.deviceInfo.companyId != "" ){
        this.deviceInfo.companyId.split(",").forEach(e => {
          if( e != "-" ){
            if( this.companyId != "" ){
              this.companyId += "," ;
            }
            this.companyId += e ;
          }
        })
      }

      if( this.deviceInfo.shipCompanyId != "" ){
        this.deviceInfo.shipCompanyId.split(",").forEach(e => {
          if( e != "-" ){
            if( this.shipCompanyId != "" ){
              this.shipCompanyId += "," ;
            }
            this.shipCompanyId += e ;
          }
        })
      }
      
      this.loadUserListByCompanyId();

      


      this.showDialog = true;
      this.isEdit = false;
      if (row) {
        this.isEdit = true;
      }
      this.form = {};
      this.listChangeCallback = callback;
      if (row != null) {
        this.form = row;
      }


      console.log( "this.defaultUserTree ------ "  );
      console.log( this.defaultUserTree[0]  );

      this.setDefaultCheckedKeys() ;

    },
    /**
     *获取公司信息
     */
    // loadCompanyList: function (){
    //   // 这里模拟异步获取数据
    //   setTimeout(() => {
    //     this.companyList = [
    //       { companyId: 'eca3392d483d497fac058c3c92832bc0', companyName: '重庆金睛兽物流科技有限公司' },
    //       { companyId: 'd012a8174b664a078d567305e85e0a30', companyName: '金睛兽' },
    //       // 更多选项...
    //     ];
    //   }, 1000);
    // },
    setDefaultCheckedKeys : function () {
      console.log( "this.$refs.tree --- " )
      console.log( this.$refs.tree );
      if( this.$refs.tree ){
        this.$refs.tree.setCheckedKeys( this.defaultUserTree  );
      }
    },

    loadUserListByCompanyId: function () {
      let that = this;
      // if (typeof (this.$route.params.deviceId) == "undefined") return;
      this.$axios({
        method: 'post',
        url: `/api/jjsCompany/getUserListByCompanyId`,
        data : {
          shipName : that.shipName ,
          companyId : that.companyId ,
          shipCompanyId : that.shipCompanyId ,
        }
      }).then( (res)=> {
        if (res.data.code === 0) {
          console.log( res.data.data ) ;
          // this.companyList.push( { shipCompanyId :'' , companyId: 'd012a8174b664a078d567305e85e0a30', companyName: '金睛兽' , uid:'' } );
          console.log( "加载 loadUserListByCompanyId " ) ;
          // companyId: "eca3392d483d497fac058c3c92832bc0"
          // companyName: "重庆金睛兽物流科技有限公司"
          // type: 1
          // companyUserList: (7) [{…}, {…}, {…}, {…}, {…}, {…}, {…}]
          //              name: "jjsAdmin"
          //              type: "公司管理员"
          //              userId: "64f999937d62483bb43a7edc"    
          this.companyUserTree = [] ;
          res.data.data.forEach(e => {
            var one = { id :"" , label : "" , children : [] } ;
            one.id = "companyId_"+e.companyId ;
            one.label = e.companyName ;
            if( e.type == 1 ){
              one.label+= "(管船)";
            }else{
              one.label+= "(船务)";
            }
            e.companyUserList.forEach(u => {
              var uInfo = { id :"" , label : "" , children : [] } ;
              uInfo.id = u.userId + "__" + u.name + "__" + e.companyId + "__" +  e.companyName ;
              uInfo.label = u.type + "_" + u.name ; 
              one.children.push( uInfo );
            })
            this.companyUserTree.push( one ) ;
          })
          

          console.log( this.companyUserTree ) ;
          this.setDefaultCheckedKeys() ;
        }

      }).catch(function (error) {
        console.log(error);
      });
    },




    /**
     * 选择船舶数据
     */
    selectShipList : function ( val ){
      console.log("selectShipList : " + val );
      if( val ){
        val = val + "" ;
        val = val.split(",")[0]; 
        this.companyList.forEach(e => {
          if( e.uidCompanyId == val ){
            this.shipList = [] ;
            this.shipList.push( {shipId:"岸基",shipName:"岸基"} );
            e.shipList.forEach( eIn=>{
              this.shipList.push( eIn );
            } )
            return;
          }
        })
      }else{
        this.shipList = [] ;
      }
      
    },

    onSubmit: function () {
      console.log("onSubmit");
      // console.log(this.form);
      // console.log( this.companyList ) ;
      // console.log( this.userList ) ;
      // console.log( this.form.isRelatedJjsCompany ) ;
      // console.log( this.form.selectedUserValue ) ;
      // console.log( this.form.selectedCompanyValue ) ;

      /**
       * 转存请求对象 
       */

      this.formRest.deviceId = this.form.deviceId ;
      this.formRest.channelId = this.form.channelId ;
      this.formRest.userList = [] ;
      if( this.$refs.tree.getCheckedKeys().length > 0  ){
        this.$refs.tree.getCheckedKeys().forEach( e => {
          let target = "companyId_";
          let contains = e.includes(target);
          if( !contains ){
            var one = { userId:"" , userName :"" , companyId : "" , companyName :"" };
            var strArr = e.split("__") ;

            one.userId = strArr[0];
            one.userName = strArr[1];
            one.companyId = strArr[2];
            one.companyName = strArr[3];

            this.formRest.userList.push( one );
          }
        })
      }
      
      this.$axios({
        method: 'post',
        url:`/api/device/upgrade/devices/updateChannelCompanyUser`,
        // params 拼接和Data里面都有
        data: this.formRest
      }).then((res) => {
        console.log(res.data)
        if (res.data.code === 0) {
          this.listChangeCallback()
        }else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    close: function () {
      this.showDialog = false;
      this.$refs.form.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/channelEditUser.vue